import React from "react"
import { get } from "lodash"
import { Form } from "antd"
import { QuestionPane } from "../Panes"
import Question from "../Question"
import { FormNavigationContext } from "../Panes/Form"
/**
 * A QuestionList contains mulitple questions that will each be shown seperately
 */

export class QuestionList extends React.Component {
  state = {
    fields: { ...this.context.result },
    visibleIds: [],
  }

  containsIdentifier(identifier) {
    return this.props.questions.reduce(
      (containedIdentifier, currentQuestion) => {
        return (
          containedIdentifier ||
          get(currentQuestion, "question.identifier") === identifier
        )
      },
      false
    )
  }

  // Being called when back is being triggered
  back() {
    this.context.goBack()
  }

  // Being called when next is being triggered
  next() {
    if (this.containsIdentifier(this.context.activeIdentifier)) {
      this.onSubmit(this.context.activeIdentifier)
    }
  }

  onSubmit = identifier => {
    if (get(identifier, "preventDefault")) {
      identifier.preventDefault()
    }

    // Validate whether currently active QuestionPane is valid
    this.props.form.validateFields([identifier], (errors, values) => {
      if (errors != null) {
        return
      }

      this.context.setFields(values)
      this.context.processedQuestion(identifier, values[identifier])
      this.setState({
        fields: {
          ...this.state.fields,
          ...values,
        },
      })
    })
  }

  render() {
    return (
      <React.Fragment>
        {this.props.questions
          .filter(question => question.__typename !== "SanityPageBreak")
          .map((question, index) => (
            <Form
              key={
                get(question, "question.identifier") ||
                `${this.props.identifier}-${question.__typename}-${index}`
              }
              onSubmit={this.onSubmit}
            >
              <QuestionPane
                identifiers={[get(question, "question.identifier")]}
                registerContext={context => (this.context = context)}
                paneWillShow={id => this.setState({ visibleIds: id })}
              >
                <Question
                  {...question}
                  {...this.props.form}
                  onSubmit={this.onSubmit}
                  setFormFields={this.context.setFields}
                  navigateTo={this.navigateTo}
                  focus={
                    this.state.visibleIds.indexOf(
                      get(question, "question.identifier")
                    ) > -1
                  }
                  value={
                    this.context.result[question.question.identifier] ||
                    this.state.fields[question.question.identifier]
                  }
                />
              </QuestionPane>
            </Form>
          ))}
      </React.Fragment>
    )
  }
}
QuestionList.contextType = FormNavigationContext
export default Form.create({ name: "QuestionListForm" })(QuestionList)
